// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610072336/js/" + chunkId + "." + {"44":"0d824f51","225":"650dcff3","481":"a501f7cd","486":"df530c32","770":"c9281da9"}[chunkId] + ".0.48763239843264794.chunk.js";
};